var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50003 1.73317C5.02727 1.73317 3.83336 2.92708 3.83336 4.39984C3.83336 4.69439 3.59458 4.93317 3.30003 4.93317C2.34725 4.93317 1.70003 5.59479 1.70003 6.2665C1.70003 6.93821 2.34725 7.59984 3.30003 7.59984C3.59458 7.59984 3.83336 7.83862 3.83336 8.13317C3.83336 8.42772 3.59458 8.6665 3.30003 8.6665C1.89639 8.6665 0.633362 7.65666 0.633362 6.2665C0.633362 5.04459 1.60918 4.11651 2.79857 3.90976C3.03856 2.0795 4.60428 0.666504 6.50003 0.666504C8.39578 0.666504 9.9615 2.0795 10.2015 3.90976C11.3909 4.11651 12.3667 5.04459 12.3667 6.2665C12.3667 7.65666 11.1037 8.6665 9.70003 8.6665C9.40548 8.6665 9.1667 8.42772 9.1667 8.13317C9.1667 7.83862 9.40548 7.59984 9.70003 7.59984C10.6528 7.59984 11.3 6.93821 11.3 6.2665C11.3 5.59479 10.6528 4.93317 9.70003 4.93317C9.40548 4.93317 9.1667 4.69439 9.1667 4.39984C9.1667 2.92708 7.97279 1.73317 6.50003 1.73317Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47715 8.82271C8.26887 8.61443 7.93118 8.61443 7.72291 8.82271L7.03336 9.51226V4.93317C7.03336 4.63862 6.79458 4.39984 6.50003 4.39984C6.20548 4.39984 5.9667 4.63862 5.9667 4.93317V9.51226L5.27715 8.82271C5.06887 8.61443 4.73118 8.61443 4.52291 8.82271C4.31463 9.03099 4.31463 9.36868 4.5229 9.57696L6.1229 11.177C6.22292 11.277 6.35858 11.3332 6.50003 11.3332C6.64148 11.3332 6.77713 11.277 6.87715 11.177L8.47715 9.57696C8.68543 9.36868 8.68543 9.03099 8.47715 8.82271Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5ed56d67d834d2d29fe011fd8a02ec3f.svg";
export { ForwardRef as ReactComponent };